import styled from 'styled-components';
import { gridConfig } from '../../fuse-responsive-grid/src/grid';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';
import variantConfig from './variant-config';

const StyledContentBanner = styled.div.attrs({
	className: 'fuse-content-banner-2',
})`
	border: none;
	display: grid;
	gap: var(--spacing-global-space7);
	padding: var(--spacing-global-space7);
	text-decoration: none;
	text-align: center;

	${(props) =>
		props.as === 'button'
			? `
		cursor: pointer;
	`
			: ``}

	${(props) => props.variant && `background: ${variantConfig[props.variant].background};`};
	box-sizing: border-box;
	box-shadow: inset 0 0 0 var(--border-width-xl)
		${(props) =>
		props.variant && variantConfig[props.variant].defaultBorder
			? 'var(--color-brand-mid)'
			: 'transparent'};

	@media screen and (min-width: ${gridConfig.m.minWidth}) {
		padding: var(--spacing-global-space8) var(--spacing-global-space7);
		box-shadow: inset 0 0 0 12px
			${(props) =>
		props.variant && variantConfig[props.variant].defaultBorder
			? 'var(--color-brand-mid)'
			: 'transparent'};
	}

	@media screen and (min-width: ${gridConfig.l.minWidth}) {
		padding: var(--spacing-global-space8) var(--spacing-global-space9);
		box-shadow: inset 0 0 0 16px
			${(props) =>
		props.variant && variantConfig[props.variant].defaultBorder
			? 'var(--color-brand-mid)'
			: 'transparent'};
	}

	.fuse-span-button {
		margin: auto;
	}

	&:focus {
		outline: var(--border-radius-s) solid var(--color-functional-focus);
		outline-offset: -2px;
	}

	&:hover {
		.fuse-span-button {
			box-shadow: var(--elevation-shadow-s);
			border: var(—border-width-xs) solid var(--color-brand-mid);
		}
	}

	&:active {
		.fuse-span-button {
			box-shadow: inset 0 0 0 var(--border-radius-s) var(--color-global-white);
			color: var(--color-brand-mid);
			background-color: var(--color-global-white);
			&:before {
				background: var(--color-brand-mid);
			}
		}
	}
`;

const StyledText = styled.div.attrs({
	className: 'fuse-content-banner-2__text',
	'data-testid': 'fuse-content-banner-2-text-test-id',
})`
	display: grid;
	gap: var(--spacing-global-space2);

	div {
		display: grid;
		gap: var(--spacing-global-space5);
	}
`;

const StyledHeading = styled(TypographyComponent).attrs({
	className: 'fuse-content-banner-2__heading',
	'data-testid': 'fuse-content-banner-2-heading-test-id',
})`
	&& {
		color: var(--color-global-white);
	}
`;

const StyledHeadingSpan = styled.span.attrs({
	className: 'fuse-content-banner-2__heading-span',
	'data-testid': 'fuse-content-banner-2-heading-span-test-id',
})`
	&& {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;

		span {
			font-size: var(--font-size-9);
			line-height: var(--font-line-height-9);
			text-transform: uppercase;
			color: ${(props) =>
		props.variant === 'brand'
			? 'var(--color-brand-enhancedText)'
			: 'var(--color-brand-onBlack)'};

			@media screen and (min-width: ${gridConfig.m.minWidth}) {
				font-size: var(--font-size-10);
				line-height: var(--font-line-height-10);
			}

			@media screen and (min-width: ${gridConfig.l.minWidth}) {
				font-size: var(--font-size-12);
				line-height: var(--font-line-height-12);
			}
		}
	}
`;

const StyledTextWrapper = styled.div.attrs({
	className: 'fuse-content-banner-2__text-wrapper',
	'data-testid': 'fuse-content-banner-2-text-wrapper-test-id',
})``;

const StyledSubHeading = styled(TypographyComponent).attrs({
	className: 'fuse-content-banner-2__subheading',
	'data-testid': 'fuse-content-banner-2-subheading-test-id',
})`
	&& {
		color: var(--color-global-white);
	}
`;

const StyledParagraph = styled(TypographyComponent).attrs({
	className: 'fuse-content-banner-2__paragraph',
	'data-testid': 'fuse-content-banner-2-paragraph-test-id',
})`
	&& {
		color: var(--color-global-white);
		margin-bottom: 0;
	}
`;

export {
	StyledContentBanner,
	StyledText,
	StyledHeading,
	StyledHeadingSpan,
	StyledSubHeading,
	StyledParagraph,
	StyledTextWrapper,
};
